import { oc } from '@orpc/contract';
import { downloadImportTemplateInputSchema, importFileSchema } from '../schemas/import.schemas.js';
export const downloadImportTemplateContract = oc
    .route({
    method: 'GET',
    path: '/import/template',
    tags: ['Import'],
    summary: 'Download the spreadsheet template for bulk run entry',
    description: 'One header row with the plan §9 column names plus a commented example row. The XLSX flavour adds a second sheet listing the vehicle, scenario and route codes that currently exist, so a filled-in template can only reference real catalogue rows. The file comes back base64-encoded — one JSON transport for the template and both uploads.',
})
    .input(downloadImportTemplateInputSchema)
    .output(importFileSchema);
//# sourceMappingURL=download-import-template.contract.js.map